<template>
  <div class="split-button d-inline-block"  :class="[classCustom]" ref="buttonSplit">
    <button
      class="btn flex-row"
      :class="[type]"
      :disabled="disabled"
      v-on="listeners"
      v-tooltip="tooltipText"
    >
      <div :class="['icon left', leftIcon]" v-if="leftIcon">&nbsp;</div>
      <div class="text" :class="[{'pl-0': leftIcon}]" v-if="text">{{text}}</div>
      <div class="button-line"></div>
      <div :class="['split-icon icon',{'active': active}]" @click.prevent="toggleContext">
        <div :class="['icon24 icon right', rightIcon]"></div>
      </div>
    </button>
    <!-- <div class="button-line"></div> -->

    <vue-context ref="actionMenu" :customPositionMenu="customPositionMenu" :customWidth="customWidth" :heightOffset="heightOffset" :widthOffset="widthOffset" @close="closeMenu">
        <li v-for="(item, index) in menuItems" :key="index">
            <div href="javascript:void(0)" :class="['context-item has-icon flex-row', item.cls]"  @click.prevent="menuClick(item, $event)"> 
              <div :class="['icon24 context-icon', item.icon]" v-if="item.icon"></div> 
              <div class="context-text flex">{{item.text}}</div>
            </div>
        </li>
    </vue-context>
  </div>
</template>
<script>
import VueContext from "@/components/shared/vue-context/vue-context";
export default {
  name: "msSplitButton",
  components: {
    VueContext
  },
  props: {
    //Text hiển thị
    text: {
      defualt: null,
      type: String
    },
    //Icon trái
    leftIcon: {
      default: null,
      type: String
    },
    //Icon phải
    rightIcon: {
      default: "chevron-down-white",
      type: String
    },
    //Loại button gồm 3 loại primary/secondary/third/four để hiện thị style tương ứng
    type: {
      default: "primary",
      type: String
    },
    /**
     * Trạng thái button disabled
     */
    disabled: {
      default: false,
      type: Boolean
    },
    /**
     * Danh sách các item của context menu
     */
    menuItems: {
      type: Array,
      default: () => {
        return [];
      }
    },
    /**
     * ĐVThi 18/02/2020
     * muốn đặt thêm stype cho lớp mục đích có cách để trên form tìm được đến control
     */    
      classCustom: {
      default: "",
      type: String
    },
    /**
     * NNLAM 26/02/2020
     * có cho phép tự custom vị trí dropdown menu hay không
     */ 
    customPositionMenu:{
      type: Boolean,
      default: false
    },
    /**
     * NNLAM 26/02/2020
     * Set lại chiều dài menu dropdown
     */
    customWidth:{
      type: Number,
      default: 0,
    },
    /**
     * NNLAM 26/02/2020
     * khoảng cách của button so với lề trên/dưới
     */
    heightOffset: {
      type: Number,
      default: 5,//25
    },
    /**
     * NNLAM 26/02/2021
     * khoảng cách của button so với lề trái/phải
     */
    widthOffset: {
      type: Number,
      default: 25
    },
    /**
     * NNLAM 26/02/2021
     * Có show menu khi click vào icon right của button không, mặc định có
     */
    hasShowMenu:{
      type: Boolean,
      default: true
    },
    /**
     * NNLAM 26/02/2021
     * Có tooltip cho btt không
     */
    tooltipText:{
      type: [String,Object],
      default: null,
    }
  },
  data() {
    return {
      active: false
    };
  },
  computed: {
    //Sự kiện từ 1 dòng dữ liệu emit ra ngoài
    listeners() {
      const me = this;
      return {
        click: event => {
          if (me.suppendClick) {
            delete me.suppendClick;
            return;
          }
          me.$emit("click", event);
        },
        mousedown: event => {
          event.preventDefault();
        },
        keydown: event => {
          me.$emit("keydown", event);
        },
        focus: event => {
          me.$emit("focus", event);
        }
      };
    }
  },
  methods: {
    /**
     * click vào icon toggle menu
     */
    toggleContext(event) {
      const me = this;

      if(me.disabled){
        return;
      }

      me.suppendClick = true;
      me.active = false;
      if(me.hasShowMenu){
        // this.$refs.actionMenu.close();
        let menu = me.$refs.actionMenu;
        if (!menu.show) {
          setTimeout(() => {
            me.active = true;
            menu.open(event);
          }, 10);
        }
      }
      me.$emit('toggleContext', event);
    },
    /**
     * click vào context menu item
     */
    menuClick(item, event) {
      this.$emit("menuclick", item, event);
    },

    closeMenu(){
      this.active = false;
    }
  },
  created(){
    
  }
};
</script>
<style scoped lang="scss">
// @media screen and (max-width: 1366px) {
// 	@import '@/assets/scss/_sm-variables.scss';
// 	@import '@/assets/scss/components/button.scss';
// }
// @media screen and (min-width: 1367px) {
// 	@import '@/assets/scss/_variables.scss';
// 	@import '@/assets/scss/components/button.scss';
// }

@import "@/assets/scss/controls/_variables.scss";
@import "@/assets/scss/components/MsButton.scss";

// .btn {
//   padding-right: 36px !important;
// }

.split-icon {
  // padding: 6px 0;
  // margin: 0 !important;
  // position: absolute;
  // top: 0px;
  width: 36px;
  height: 24px;
  margin: 0 !important;
  .icon {
    margin: 0;
    cursor: pointer;
  }
}

.context-item {
  line-height: 26px;
  margin: 0px 8px 4px 8px;
  height: 36px;
  padding: 2px 8px;
  line-height: 36px;
  border-radius: 4px;
  .context-text{
    padding: 0 8px;
  }
  &:hover {
    cursor: pointer;
    background: $hover-bg;
    color: #14aa8a;
  }
}
.context-icon {
  margin-right: 8px;
}
.color-red{
 color: #FF0000
}
</style>

